import { DocumentItem } from '@klubovna/shared-models';

export interface DocumentsState {
  documents: DocumentItem[];
  loading: boolean;
  error: string | null;
}

export const initialDocumentsState: DocumentsState = {
  documents: [],
  loading: false,
  error: null,
};
